/**
 * 事件绑定对象
 */
import {IEvent} from "./IEvent";
import {IEventBinder} from "./IEventBinder";

export class EventBinder<T, K extends keyof T, F extends T[K]> implements IEventBinder {
    
    public constructor(public mgr: IEvent<T>, public key: K, public func: F) {
    }

    /**
     * 移除当前事件监听
     */
    public removeListener() {
        this.mgr.removeEventListener(this as any);
    }
}